import { useMemo } from 'react';

import { PublicPage } from 'api/website';

import { useContentSubsite } from './useContentSubsite';

type Props = {
  content: PublicPage | undefined;
};

export function useContentDefaultSearchType({
  content,
}: Props): DefaultSearchType {
  const subsite = useContentSubsite({ content });
  const heroSearch = content && content.heroSearch;

  return useMemo(() => {
    if (heroSearch && heroSearch.defaultSearchFilters) {
      return heroSearch.defaultSearchFilters.type;
    }

    if (subsite) return subsite.defaultSearchType;

    return 'JOB';
  }, [heroSearch, subsite]);
}
